import React from "react";

function Banner() {
  return (
    <div className="hs-removing:-translate-y-full bg-primary">
      <div className="max-w-[80rem] mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-3">
        <div className="flex items-center justify-between">
          {/* Contact Info */}
          <div className="flex items-center gap-3 sm:gap-6">
            <p className="text-white flex items-center text-xs sm:text-sm">
              <i className="fa-duotone fa-phone-volume mr-1 sm:mr-2"></i>
              <span>+92 343 2629294</span>
            </p>
            <p className="text-white flex items-center text-xs sm:text-sm">
              <i className="fa-duotone fa-paper-plane mr-1 sm:mr-2"></i>
              <span>info@synaptrixsol.com</span>
            </p>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-3 sm:gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-gray-200 transition-colors duration-200"
            >
              <i className="fa-brands fa-linkedin-in text-base sm:text-lg"></i>
            </a>
            <a
              href="https://wa.me/+923432629294?text=Hello, I need help with your services."
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-gray-200 transition-colors duration-200"
            >
              <i className="fa-brands fa-whatsapp text-base sm:text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;